import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuickBooksService } from '../../services/quick-books.service';
import { first, map } from 'rxjs';
import { SubSink } from 'subsink';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit, OnDestroy {
  public params;
  public isQuickBooksEnabled: boolean = true;
  public accessToken: string | undefined;
  public refreshToken: string | undefined;
  public subs$: SubSink = new SubSink();
  public return_message = "";
  public isLoading:boolean = true;

  constructor(
    public quickBooks: QuickBooksService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _translation: TranslateService,
  ) { 
    this.return_message = this._translation.instant('quickbooks.please_wait');
  }

  ngOnInit(): void {
  this.params = this._route.snapshot.queryParams;
  const code = this.params['code'];
  const realmId = this.params['realmId']
  this.subs$.add(this.quickBooks.getAccessToken(code, realmId)
  .pipe(
    first(),
    map((response: { data: { accessToken: string, refreshToken: string }}) => {
      if (response['data'].accessToken === undefined) {
        var error_message = this._translation.instant('quickbooks.error_message');
        alert(error_message);
        // this.isQuickBooksEnabled = false;
      }
      // this.isQuickBooksEnabled = true;
      this.accessToken = response.data.accessToken;
      this.refreshToken = response.data.refreshToken;
      this.return_message = this._translation.instant('quickbooks.return_message');
      this.isLoading = false;
    })
  ).subscribe()
);
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }

  public onClose(authorized){
    if(window.opener) {
      const customEvent = new CustomEvent('quickbooksPopup', { detail: {
        accessToken: this.accessToken,
        refreshToken: this.refreshToken,
        realmId: this.params['realmId'],
        authorized: authorized 
      }});
      
      window.opener.dispatchEvent(customEvent);
      window.open('','_parent','');
      window.close();
    }
  }

}